import React from "react";

const EditIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path d="M3.7929 16.4645C3.60536 16.652 3.5 16.9064 3.5 17.1716V20C3.5 20.5523 3.94772 21 4.5 21H7.32849C7.5937 21 7.84806 20.8946 8.03559 20.7071L17.2072 11.5355C17.5977 11.145 17.5977 10.5118 17.2072 10.1213L14.3788 7.29285C13.9883 6.90232 13.3551 6.90232 12.9646 7.29285L3.7929 16.4645ZM20.8765 4.98264L19.5174 3.62354C19.135 3.24117 18.6164 3.02637 18.0756 3.02637C17.5349 3.02637 17.0163 3.24117 16.6339 3.62354L15.7929 4.46454C15.4024 4.85506 15.4024 5.48822 15.7929 5.87874L18.6213 8.70719C19.0118 9.09773 19.645 9.09773 20.0355 8.70718L20.8765 7.86614C21.2589 7.48375 21.4737 6.96514 21.4737 6.42439C21.4737 5.88363 21.2589 5.36502 20.8765 4.98264Z" fill="white" />
        </svg>
    );
};

export default EditIcon;